import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { NgxMaskModule } from 'ngx-mask';
import {MatDialogModule} from '@angular/material/dialog';
// import { NgChartsModule } from 'ng2-charts';
import { ChartsModule } from 'ng2-charts';

import { ReputationRoutingModule } from './reputation-routing.module';
import { ReputationComponent } from './reputation.component';
import { ReviewUrlListComponent } from './review-url-list/review-url-list.component';
import { AddEditReviewUrlComponent } from './add-edit-review-url/add-edit-review-url.component';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { FeedbackDetailsComponent } from './feedback-details/feedback-details.component';
import { FeedbackStatusModalComponent } from './feedback-status-modal/feedback-status-modal.component';
import { UserReviewListComponent } from './user-review-list/user-review-list.component';
import { UserReviewAddEditComponent } from './user-review-add-edit/user-review-add-edit.component';
import { StatisticsReviewComponent } from './statistics-review/statistics-review.component';


@NgModule({
  declarations: [
    ReputationComponent,
    ReviewUrlListComponent,
    AddEditReviewUrlComponent,
    FeedbackListComponent,
    FeedbackDetailsComponent,
    FeedbackStatusModalComponent,
    UserReviewListComponent,
    UserReviewAddEditComponent,
    StatisticsReviewComponent
  ],
  imports: [
    CommonModule,
    ReputationRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    NgxMaskModule,
    MatDialogModule,
    ChartsModule,
    // NgChartsModule
  ]
})
export class ReputationModule { }
